const BASE = process.env.VUE_APP_ENV === 'preview' ? 'api/gp-caishang-staging' : 'api/gp-caishang'
const urls = {
  /*
  * id
  * */
  courseDetail: 'get /api/course/service/getCourseDetailsById',
  // 获取财商文章列表
  getCSArticleList: 'get /api/user/service/articleColumnPage',
  // 获取财商回放列表
  getCSRePlayList: 'get /api/user/service/tapeHistory',

  courseIntro: 'get /api/course/service/getCoursePage',

  unActivatedList: 'get /api/order/service/getUnActivationCourses',

  courseActivate: 'post /api/order/service/activation'
}

const URLS = {}
for (let k in urls) {
  const arr = urls[k].split(' ')
  URLS[k] = `${arr[0]} ${BASE}${arr[1]}`
}
export default URLS
